define("discourse/plugins/discourse-local-dates/discourse/components/discourse-local-dates-create-form", ["exports", "discourse-common/utils/decorators", "@ember/component", "@ember/object", "I18n", "discourse-common/config/environment", "rsvp", "discourse/lib/text", "discourse-common/lib/debounce", "@ember/utils", "discourse/lib/load-script", "@ember/object/computed", "discourse/lib/computed", "@ember/runloop", "discourse-common/lib/get-owner", "discourse/lib/local-dates", "discourse/plugins/discourse-local-dates/lib/local-date-markup-generator"], function (_exports, _decorators, _component, _object, _I18n, _environment, _rsvp, _text, _debounce, _utils, _loadScript, _computed, _computed2, _runloop, _getOwner, _localDates, _localDateMarkupGenerator) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.observes)("computedConfig.{from,to,options}", "options", "isValid", "isRange"), _dec2 = (0, _decorators.default)("date", "toDate", "toTime"), _dec3 = (0, _decorators.default)("computedConfig", "isRange"), _dec4 = (0, _decorators.default)("date", "time", "isRange", "options.{format,timezone}"), _dec5 = (0, _decorators.default)("toDate", "toTime", "isRange", "options.{timezone,format}"), _dec6 = (0, _decorators.default)("recurring", "timezones", "timezone", "format"), _dec7 = (0, _decorators.default)("fromConfig.{date}", "toConfig.{date}", "options.{recurring,timezones,timezone,format}"), _dec8 = (0, _decorators.default)("currentUserTimezone"), _dec9 = (0, _decorators.default)("formats"), _dec10 = (0, _decorators.default)("advancedMode"), _dec11 = (0, _decorators.default)("computedConfig.{from,to,options}", "options", "isValid", "isRange"), _dec12 = (0, _decorators.default)("fromConfig.dateTime"), _dec13 = (0, _decorators.default)("toConfig.dateTime", "toSelected"), (_obj = {
    timeFormat: "HH:mm:ss",
    dateFormat: "YYYY-MM-DD",
    dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
    date: null,
    toDate: null,
    time: null,
    toTime: null,
    format: null,
    formats: null,
    recurring: null,
    advancedMode: false,
    timezone: null,
    fromSelected: null,
    fromFilled: (0, _computed.notEmpty)("date"),
    toSelected: null,
    toFilled: (0, _computed.notEmpty)("toDate"),
    init: function init() {
      this._super.apply(this, arguments);

      this._picker = null;
      this.setProperties({
        timezones: [],
        formats: (this.siteSettings.discourse_local_dates_default_formats || "").split("|").filter(function (f) {
          return f;
        }),
        timezone: moment.tz.guess(),
        date: moment().format(this.dateFormat)
      });
    },
    didInsertElement: function didInsertElement() {
      var _this = this;

      this._super.apply(this, arguments);

      this._setupPicker().then(function (picker) {
        _this._picker = picker;

        _this.send("focusFrom");
      });
    },
    _renderPreview: function _renderPreview() {
      (0, _debounce.default)(this, function () {
        var _this2 = this;

        var markup = this.markup;

        if (markup) {
          (0, _text.cookAsync)(markup).then(function (result) {
            _this2.set("currentPreview", result);

            (0, _runloop.schedule)("afterRender", function () {
              (0, _localDates.applyLocalDates)(document.querySelectorAll(".preview .discourse-local-date"), _this2.siteSettings);
            });
          });
        }
      }, _environment.INPUT_DELAY);
    },
    isRange: function isRange(date, toDate, toTime) {
      return date && (toDate || toTime);
    },
    isValid: function isValid(config, isRange) {
      var fromConfig = config.from;

      if (!config.from.dateTime || !config.from.dateTime.isValid()) {
        return false;
      }

      if (isRange) {
        var toConfig = config.to;

        if (!toConfig.dateTime || !toConfig.dateTime.isValid() || toConfig.dateTime.diff(fromConfig.dateTime) < 0) {
          return false;
        }
      }

      return true;
    },
    fromConfig: function fromConfig(date, time, isRange) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var timeInferred = time ? false : true;
      var dateTime;

      if (!timeInferred) {
        dateTime = moment.tz("".concat(date, " ").concat(time), options.timezone);
      } else {
        dateTime = moment.tz(date, options.timezone);
      }

      if (!timeInferred) {
        time = dateTime.format(this.timeFormat);
      }

      var format = options.format;

      if (timeInferred && this.formats.includes(format)) {
        format = "LL";
      }

      return _object.default.create({
        date: dateTime.format(this.dateFormat),
        time: time,
        dateTime: dateTime,
        format: format,
        range: isRange ? "start" : false
      });
    },
    toConfig: function toConfig(date, time, isRange) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var timeInferred = time ? false : true;

      if (time && !date) {
        date = moment().format(this.dateFormat);
      }

      var dateTime;

      if (!timeInferred) {
        dateTime = moment.tz("".concat(date, " ").concat(time), options.timezone);
      } else {
        dateTime = moment.tz(date, options.timezone).endOf("day");
      }

      if (!timeInferred) {
        time = dateTime.format(this.timeFormat);
      }

      var format = options.format;

      if (timeInferred && this.formats.includes(format)) {
        format = "LL";
      }

      return _object.default.create({
        date: dateTime.format(this.dateFormat),
        time: time,
        dateTime: dateTime,
        format: format,
        range: isRange ? "end" : false
      });
    },
    options: function options(recurring, timezones, timezone, format) {
      return _object.default.create({
        recurring: recurring,
        timezones: timezones,
        timezone: timezone,
        format: format
      });
    },
    computedConfig: function computedConfig(fromConfig, toConfig, options) {
      return _object.default.create({
        from: fromConfig,
        to: toConfig,
        options: options
      });
    },
    currentUserTimezone: function currentUserTimezone() {
      return moment.tz.guess();
    },
    allTimezones: function allTimezones() {
      return moment.tz.names();
    },
    timezoneIsDifferentFromUserTimezone: (0, _computed2.propertyNotEqual)("currentUserTimezone", "options.timezone"),
    formattedCurrentUserTimezone: function formattedCurrentUserTimezone(timezone) {
      return timezone.replace("_", " ").replace("Etc/", "").replace("/", ", ");
    },
    previewedFormats: function previewedFormats(formats) {
      return formats.map(function (format) {
        return {
          format: format,
          preview: moment().format(format)
        };
      });
    },
    recurringOptions: function recurringOptions() {
      var key = "discourse_local_dates.create.form.recurring";
      return [{
        name: _I18n.default.t("".concat(key, ".every_day")),
        id: "1.days"
      }, {
        name: _I18n.default.t("".concat(key, ".every_week")),
        id: "1.weeks"
      }, {
        name: _I18n.default.t("".concat(key, ".every_two_weeks")),
        id: "2.weeks"
      }, {
        name: _I18n.default.t("".concat(key, ".every_month")),
        id: "1.months"
      }, {
        name: _I18n.default.t("".concat(key, ".every_two_months")),
        id: "2.months"
      }, {
        name: _I18n.default.t("".concat(key, ".every_three_months")),
        id: "3.months"
      }, {
        name: _I18n.default.t("".concat(key, ".every_six_months")),
        id: "6.months"
      }, {
        name: _I18n.default.t("".concat(key, ".every_year")),
        id: "1.years"
      }];
    },
    _generateDateMarkup: function _generateDateMarkup(fromDateTime, options, isRange, toDateTime) {
      return (0, _localDateMarkupGenerator.default)(fromDateTime, options, isRange, toDateTime);
    },
    toggleModeBtnLabel: function toggleModeBtnLabel(advancedMode) {
      return advancedMode ? "discourse_local_dates.create.form.simple_mode" : "discourse_local_dates.create.form.advanced_mode";
    },
    markup: function markup(config, options, isValid, isRange) {
      var text;

      if (isValid && config.from) {
        if (config.to && config.to.range) {
          text = this._generateDateMarkup(config.from, options, isRange, config.to);
        } else {
          text = this._generateDateMarkup(config.from, options, isRange);
        }
      }

      return text;
    },
    formattedFrom: function formattedFrom(dateTime) {
      return dateTime.format("LLLL");
    },
    formattedTo: function formattedTo(dateTime, toSelected) {
      var emptyText = toSelected ? "&nbsp;" : _I18n.default.t("discourse_local_dates.create.form.until");
      return dateTime.isValid() ? dateTime.format("LLLL") : emptyText;
    },
    actions: {
      setTime: function setTime(event) {
        this._setTimeIfValid(event.target.value, "time");
      },
      setToTime: function setToTime(event) {
        this._setTimeIfValid(event.target.value, "toTime");
      },
      eraseToDateTime: function eraseToDateTime() {
        this.setProperties({
          toDate: null,
          toTime: null
        });

        this._setPickerDate(null);
      },
      focusFrom: function focusFrom() {
        this.setProperties({
          fromSelected: true,
          toSelected: false
        });

        this._setPickerDate(this.get("fromConfig.date"));

        this._setPickerMinDate(null);
      },
      focusTo: function focusTo() {
        this.setProperties({
          toSelected: true,
          fromSelected: false
        });

        this._setPickerDate(this.get("toConfig.date"));

        this._setPickerMinDate(this.get("fromConfig.date"));
      },
      advancedMode: function advancedMode() {
        this.toggleProperty("advancedMode");
      },
      save: function save() {
        var markup = this.markup;

        if (markup) {
          this._closeModal();

          this.insertDate(markup);
        }
      },
      cancel: function cancel() {
        this._closeModal();
      }
    },
    _setTimeIfValid: function _setTimeIfValid(time, key) {
      if ((0, _utils.isEmpty)(time)) {
        this.set(key, null);
        return;
      }

      if (/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) {
        this.set(key, time);
      }
    },
    _setupPicker: function _setupPicker() {
      var _this3 = this;

      return new _rsvp.Promise(function (resolve) {
        (0, _loadScript.default)("/javascripts/pikaday.js").then(function () {
          var options = {
            field: _this3.element.querySelector(".fake-input"),
            container: _this3.element.querySelector("#picker-container-".concat(_this3.elementId)),
            bound: false,
            format: "YYYY-MM-DD",
            reposition: false,
            firstDay: 1,
            setDefaultDate: true,
            keyboardInput: false,
            i18n: {
              previousMonth: _I18n.default.t("dates.previous_month"),
              nextMonth: _I18n.default.t("dates.next_month"),
              months: moment.months(),
              weekdays: moment.weekdays(),
              weekdaysShort: moment.weekdaysMin()
            },
            onSelect: function onSelect(date) {
              var formattedDate = moment(date).format("YYYY-MM-DD");

              if (_this3.fromSelected) {
                _this3.set("date", formattedDate);
              }

              if (_this3.toSelected) {
                _this3.set("toDate", formattedDate);
              }
            }
          };
          resolve(new Pikaday(options));
        });
      });
    },
    _setPickerMinDate: function _setPickerMinDate(date) {
      var _this4 = this;

      if (date && !moment(date, this.dateFormat).isValid()) {
        date = null;
      }

      (0, _runloop.schedule)("afterRender", function () {
        _this4._picker.setMinDate(moment(date, _this4.dateFormat).toDate());
      });
    },
    _setPickerDate: function _setPickerDate(date) {
      var _this5 = this;

      if (date && !moment(date, this.dateFormat).isValid()) {
        date = null;
      }

      (0, _runloop.schedule)("afterRender", function () {
        _this5._picker.setDate(moment.utc(date), true);
      });
    },
    _closeModal: function _closeModal() {
      var composer = (0, _getOwner.getOwner)(this).lookup("controller:composer");
      composer.send("closeModal");
    }
  }, (_applyDecoratedDescriptor(_obj, "_renderPreview", [_dec], Object.getOwnPropertyDescriptor(_obj, "_renderPreview"), _obj), _applyDecoratedDescriptor(_obj, "isRange", [_dec2], Object.getOwnPropertyDescriptor(_obj, "isRange"), _obj), _applyDecoratedDescriptor(_obj, "isValid", [_dec3], Object.getOwnPropertyDescriptor(_obj, "isValid"), _obj), _applyDecoratedDescriptor(_obj, "fromConfig", [_dec4], Object.getOwnPropertyDescriptor(_obj, "fromConfig"), _obj), _applyDecoratedDescriptor(_obj, "toConfig", [_dec5], Object.getOwnPropertyDescriptor(_obj, "toConfig"), _obj), _applyDecoratedDescriptor(_obj, "options", [_dec6], Object.getOwnPropertyDescriptor(_obj, "options"), _obj), _applyDecoratedDescriptor(_obj, "computedConfig", [_dec7], Object.getOwnPropertyDescriptor(_obj, "computedConfig"), _obj), _applyDecoratedDescriptor(_obj, "currentUserTimezone", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "currentUserTimezone"), _obj), _applyDecoratedDescriptor(_obj, "allTimezones", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "allTimezones"), _obj), _applyDecoratedDescriptor(_obj, "formattedCurrentUserTimezone", [_dec8], Object.getOwnPropertyDescriptor(_obj, "formattedCurrentUserTimezone"), _obj), _applyDecoratedDescriptor(_obj, "previewedFormats", [_dec9], Object.getOwnPropertyDescriptor(_obj, "previewedFormats"), _obj), _applyDecoratedDescriptor(_obj, "recurringOptions", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "recurringOptions"), _obj), _applyDecoratedDescriptor(_obj, "toggleModeBtnLabel", [_dec10], Object.getOwnPropertyDescriptor(_obj, "toggleModeBtnLabel"), _obj), _applyDecoratedDescriptor(_obj, "markup", [_dec11], Object.getOwnPropertyDescriptor(_obj, "markup"), _obj), _applyDecoratedDescriptor(_obj, "formattedFrom", [_dec12], Object.getOwnPropertyDescriptor(_obj, "formattedFrom"), _obj), _applyDecoratedDescriptor(_obj, "formattedTo", [_dec13], Object.getOwnPropertyDescriptor(_obj, "formattedTo"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-local-dates/discourse/controllers/discourse-local-dates-create-modal", ["exports", "@ember/controller", "discourse/mixins/modal-functionality", "@ember/runloop"], function (_exports, _controller, _modalFunctionality, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend(_modalFunctionality.default, {
    onShow: function onShow() {
      (0, _runloop.schedule)("afterRender", function () {
        var fromButton = document.getElementById("from-date-time");
        fromButton && fromButton.focus();
      });
    },
    onClose: function onClose() {
      (0, _runloop.schedule)("afterRender", function () {
        var localDatesBtn = document.querySelector(".d-editor-button-bar .local-dates.btn");
        localDatesBtn && localDatesBtn.focus();
      });
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/components/discourse-local-dates-create-form"] = Ember.HTMLBars.template({"id":null,"block":"[[[8,[39,0],null,[[\"@title\",\"@class\",\"@style\"],[\"discourse_local_dates.title\",\"discourse-local-dates-create-modal\",\"overflow: auto\"]],[[\"default\"],[[[[1,\"\\n\\n  \"],[10,0],[14,0,\"form\"],[12],[1,\"\\n\"],[41,[30,0,[\"isValid\"]],[[[41,[30,0,[\"timezoneIsDifferentFromUserTimezone\"]],[[[1,\"        \"],[10,0],[14,0,\"preview alert alert-info\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"discourse_local_dates.create.form.current_timezone\"],null]],[1,\"\\n          \"],[10,\"b\"],[12],[1,[30,0,[\"formattedCurrentUserTimezone\"]]],[13],[1,[30,0,[\"currentPreview\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"      \"],[10,0],[14,0,\"validation-error alert alert-error\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"discourse_local_dates.create.form.invalid_date\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n    \"],[1,[30,0,[\"computeDate\"]]],[1,\"\\n\\n    \"],[10,0],[14,0,\"date-time-configuration\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"inputs-panel\"],[12],[1,\"\\n        \"],[10,0],[15,0,[29,[\"date-time-control from \",[52,[30,0,[\"fromSelected\"]],\"is-selected\"],\" \",[52,[30,0,[\"fromFilled\"]],\"is-filled\"]]]],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"calendar-alt\"],null]],[1,\"\\n          \"],[8,[39,4],null,[[\"@id\",\"@action\",\"@translatedLabel\",\"@class\"],[\"from-date-time\",[28,[37,5],[[30,0],\"focusFrom\"],null],[30,0,[\"formattedFrom\"]],\"date-time\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[15,0,[29,[\"date-time-control to \",[52,[30,0,[\"toSelected\"]],\"is-selected\"],\" \",[52,[30,0,[\"toFilled\"]],\"is-filled\"]]]],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"calendar-alt\"],null]],[1,\"\\n          \"],[8,[39,4],null,[[\"@action\",\"@translatedLabel\",\"@class\"],[[28,[37,5],[[30,0],\"focusTo\"],null],[30,0,[\"formattedTo\"]],\"date-time\"]],null],[1,\"\\n\"],[41,[30,0,[\"toFilled\"]],[[[1,\"            \"],[8,[39,4],[[16,\"action\",[28,[37,5],[[30,0],\"eraseToDateTime\"],null]]],[[\"@icon\",\"@class\"],[\"times\",\"delete-to-date\"]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"site\",\"mobileView\"]]],[[[1,\"          \"],[8,[39,7],null,[[\"@options\",\"@value\",\"@onChange\"],[[28,[37,8],null,[[\"icon\"],[\"globe\"]]],[30,0,[\"timezone\"]],[28,[37,5],[[30,0],[28,[37,9],[[30,0,[\"timezone\"]]],null]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"picker-panel\"],[12],[1,\"\\n        \"],[8,[39,10],[[24,0,\"fake-input\"]],null,null],[1,\"\\n        \"],[10,0],[14,0,\"date-picker\"],[15,1,[29,[\"picker-container-\",[30,0,[\"elementId\"]]]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"fromSelected\"]],[[[1,\"          \"],[10,0],[14,0,\"time-pickers\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"far-clock\"],null]],[1,\"\\n            \"],[8,[39,10],[[16,\"maxlength\",5],[24,\"placeholder\",\"hh:mm\"],[24,0,\"time-picker\"],[4,[38,11],[\"input\",[28,[37,5],[[30,0],\"setTime\"],null]],null]],[[\"@type\",\"@value\"],[\"time\",[30,0,[\"time\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"toSelected\"]],[[[41,[30,0,[\"toDate\"]],[[[1,\"            \"],[10,0],[14,0,\"time-pickers\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"far-clock\"],null]],[1,\"\\n              \"],[8,[39,10],[[16,\"maxlength\",5],[24,\"placeholder\",\"hh:mm\"],[24,0,\"time-picker\"],[4,[38,11],[\"input\",[28,[37,5],[[30,0],\"setToTime\"],null]],null]],[[\"@type\",\"@value\"],[\"time\",[30,0,[\"toTime\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"        \"],[8,[39,7],null,[[\"@value\",\"@options\",\"@onChange\"],[[30,0,[\"timezone\"]],[28,[37,8],null,[[\"icon\"],[\"globe\"]]],[28,[37,5],[[30,0],[28,[37,9],[[30,0,[\"timezone\"]]],null]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"advancedMode\"]],[[[1,\"      \"],[10,0],[14,0,\"advanced-options\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"isRange\"]]],[[[1,\"          \"],[10,0],[14,0,\"control-group recurrence\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"discourse_local_dates.create.form.recurring_title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,12],[[28,[37,2],[\"discourse_local_dates.create.form.recurring_description\"],null]],null]],[13],[1,\"\\n            \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n              \"],[8,[39,13],null,[[\"@content\",\"@class\",\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"recurringOptions\"]],\"recurrence-input\",[30,0,[\"recurring\"]],[28,[37,5],[[30,0],[28,[37,9],[[30,0,[\"recurring\"]]],null]],null],[28,[37,8],null,[[\"none\"],[\"discourse_local_dates.create.form.recurring_none\"]]]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,0],[14,0,\"control-group format\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,2],[\"discourse_local_dates.create.form.format_title\"],null]],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"discourse_local_dates.create.form.format_description\"],null]],[1,\"\\n            \"],[10,3],[14,\"target\",\"_blank\"],[14,6,\"https://momentjs.com/docs/#/parsing/string-format/\"],[14,\"rel\",\"noopener noreferrer\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"question-circle\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n            \"],[8,[39,14],null,[[\"@value\",\"@class\"],[[30,0,[\"format\"]],\"format-input\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"formats\"],[12],[1,\"\\n\"],[42,[28,[37,16],[[28,[37,16],[[30,0,[\"previewedFormats\"]]],null]],null],null,[[[1,\"              \"],[10,\"li\"],[14,0,\"format\"],[12],[1,\"\\n                \"],[11,3],[24,0,\"moment-format\"],[24,6,\"\"],[4,[38,5],[[30,0],[28,[37,9],[[30,0,[\"format\"]]],null],[30,1,[\"format\"]]],null],[12],[1,\"\\n                  \"],[1,[30,1,[\"format\"]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,1],[14,0,\"previewed-format\"],[12],[1,\"\\n                  \"],[1,[30,1,[\"preview\"]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[1]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"control-group timezones\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,2],[\"discourse_local_dates.create.form.timezones_title\"],null]],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,2],[\"discourse_local_dates.create.form.timezones_description\"],null]],[13],[1,\"\\n          \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n            \"],[8,[39,17],null,[[\"@valueProperty\",\"@nameProperty\",\"@class\",\"@content\",\"@value\",\"@options\"],[null,null,\"timezones-input\",[30,0,[\"allTimezones\"]],[30,0,[\"timezones\"]],[28,[37,8],null,[[\"allowAny\",\"maximum\"],[false,5]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[10,0],[14,0,\"modal-footer discourse-local-dates-create-modal-footer\"],[12],[1,\"\\n\"],[41,[30,0,[\"isValid\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@class\",\"@action\",\"@label\"],[\"btn-primary\",[28,[37,5],[[30,0],\"save\"],null],\"discourse_local_dates.create.form.insert\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[11,3],[24,0,\"cancel-action\"],[24,6,\"\"],[4,[38,5],[[30,0],\"cancel\"],null],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"cancel\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,4],null,[[\"@class\",\"@action\",\"@icon\",\"@label\"],[\"btn-default advanced-mode-btn\",[28,[37,5],[[30,0],\"advancedMode\"],null],\"cog\",[30,0,[\"toggleModeBtnLabel\"]]]],null],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"previewedFormat\"],false,[\"d-modal-body\",\"if\",\"i18n\",\"d-icon\",\"d-button\",\"action\",\"unless\",\"timezone-input\",\"hash\",\"mut\",\"input\",\"on\",\"html-safe\",\"combo-box\",\"text-field\",\"each\",\"-track-array\",\"multi-select\"]]","moduleName":"javascripts/discourse/templates/components/discourse-local-dates-create-form","isStrictMode":false});
Ember.TEMPLATES["javascripts/modal/discourse-local-dates-create-modal"] = Ember.HTMLBars.template({"id":null,"block":"[[[8,[39,0],null,[[\"@config\",\"@insertDate\"],[[30,0,[\"config\"]],[30,0,[\"insertDate\"]]]],null],[1,\"\\n\"]],[],false,[\"discourse-local-dates-create-form\"]]","moduleName":"javascripts/discourse/templates/modal/discourse-local-dates-create-modal","isStrictMode":false});
define("discourse/plugins/discourse-local-dates/initializers/discourse-local-dates", ["exports", "discourse-common/lib/deprecated", "discourse-common/lib/get-owner", "../lib/local-date-builder", "discourse/lib/plugin-api", "discourse/lib/show-modal", "discourse/lib/download-calendar", "discourse-common/lib/icon-library", "I18n", "discourse/lib/d-popover", "discourse/lib/to-markdown", "discourse/plugins/discourse-local-dates/lib/local-date-markup-generator"], function (_exports, _deprecated, _getOwner, _localDateBuilder, _pluginApi, _showModal, _downloadCalendar, _iconLibrary, _I18n, _dPopover, _toMarkdown, _localDateMarkupGenerator) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.applyLocalDates = applyLocalDates;
  _exports.default = void 0;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  // Import applyLocalDates from discourse/lib/local-dates instead
  function applyLocalDates(dates, siteSettings) {
    if (!siteSettings.discourse_local_dates_enabled) {
      return;
    }

    var currentUserTZ = moment.tz.guess();
    dates.forEach(function (element) {
      var _element$classList;

      var opts = buildOptionsFromElement(element, siteSettings);
      var localDateBuilder = new _localDateBuilder.default(opts, currentUserTZ).build();
      element.innerText = "";
      element.insertAdjacentHTML("beforeend", "\n        <svg class=\"fa d-icon d-icon-globe-americas svg-icon\" xmlns=\"http://www.w3.org/2000/svg\">\n          <use href=\"#globe-americas\"></use>\n        </svg>\n        <span class=\"relative-time\">".concat(localDateBuilder.formatted, "</span>\n      "));
      element.setAttribute("aria-label", localDateBuilder.textPreview);
      var classes = ["cooked-date"];

      if (localDateBuilder.pastEvent) {
        classes.push("past");
      }

      (_element$classList = element.classList).add.apply(_element$classList, classes);
    });
  }

  function buildOptionsFromElement(element, siteSettings) {
    var opts = {};
    var dataset = element.dataset;

    if (_rangeElements(element).length === 2) {
      opts.duration = _calculateDuration(element);
    }

    opts.time = dataset.time;
    opts.date = dataset.date;
    opts.recurring = dataset.recurring;
    opts.timezones = (dataset.timezones || siteSettings.discourse_local_dates_default_timezones || "Etc/UTC").split("|").filter(Boolean);
    opts.timezone = dataset.timezone;
    opts.calendar = (dataset.calendar || "on") === "on";
    opts.displayedTimezone = dataset.displayedTimezone;
    opts.format = dataset.format || (opts.time ? "LLL" : "LL");
    opts.countdown = dataset.countdown;
    return opts;
  }

  function buildOptionsFromMarkdownTag(element) {
    var opts = {}; // siteSettings defaults as used by buildOptionsFromElement are purposefully
    // ommitted to reproduce exactly what was on the original element

    opts.time = element.attributes["data-time"];
    opts.date = element.attributes["data-date"];
    opts.recurring = element.attributes["data-recurring"];
    opts.timezones = element.attributes["data-timezones"];
    opts.timezone = element.attributes["data-timezone"];
    opts.calendar = (element.attributes["data-calendar"] || "on") === "on";
    opts.displayedTimezone = element.attributes["data-displayed-timezone"];
    opts.format = element.attributes["data-format"];
    opts.countdown = element.attributes["data-countdown"];
    return opts;
  }

  function _rangeElements(element) {
    if (!element.parentElement) {
      return [];
    } // TODO: element.parentElement.children.length !== 2 is a fallback to old solution for ranges
    // Condition can be removed after migration to [date-range]


    if (element.dataset.range !== "true" && element.parentElement.children.length !== 2) {
      return [element];
    }

    return Array.from(element.parentElement.children).filter(function (span) {
      return span.dataset.date;
    });
  }

  function initializeDiscourseLocalDates(api) {
    var siteSettings = api.container.lookup("service:site-settings");

    var defaultTitle = _I18n.default.t("discourse_local_dates.default_title", {
      site_name: siteSettings.title
    });

    api.decorateCookedElement(function (elem, helper) {
      var _helper$getModel, _helper$getModel$topi;

      var dates = elem.querySelectorAll(".discourse-local-date");
      applyLocalDates(dates, siteSettings);
      var topicTitle = helper === null || helper === void 0 ? void 0 : (_helper$getModel = helper.getModel()) === null || _helper$getModel === void 0 ? void 0 : (_helper$getModel$topi = _helper$getModel.topic) === null || _helper$getModel$topi === void 0 ? void 0 : _helper$getModel$topi.title;
      dates.forEach(function (date) {
        date.dataset.title = date.dataset.title || topicTitle || defaultTitle;
      });
    }, {
      id: "discourse-local-date"
    });
    api.onToolbarCreate(function (toolbar) {
      toolbar.addButton({
        title: "discourse_local_dates.title",
        id: "local-dates",
        group: "extras",
        icon: "calendar-alt",
        sendAction: function sendAction(event) {
          return toolbar.context.send("insertDiscourseLocalDate", event);
        }
      });
    });
    api.modifyClass("component:d-editor", {
      pluginId: "discourse-local-dates",
      actions: {
        insertDiscourseLocalDate: function insertDiscourseLocalDate(toolbarEvent) {
          (0, _showModal.default)("discourse-local-dates-create-modal").setProperties({
            insertDate: function insertDate(markup) {
              toolbarEvent.addText(markup);
            }
          });
        }
      }
    });
    (0, _toMarkdown.addTextDecorateCallback)(function (text, nextElement, _previousElement, metadata) {
      var _nextElement$attribut;

      if (metadata.discourseLocalDateStartRangeOpts && nextElement !== null && nextElement !== void 0 && (_nextElement$attribut = nextElement.attributes.class) !== null && _nextElement$attribut !== void 0 && _nextElement$attribut.includes("discourse-local-date") && text === "→") {
        return "";
      }
    });
    (0, _toMarkdown.addTagDecorateCallback)(function () {
      var _this$element$attribu;

      if ((_this$element$attribu = this.element.attributes.class) !== null && _this$element$attribu !== void 0 && _this$element$attribu.includes("discourse-local-date")) {
        if (this.metadata.discourseLocalDateStartRangeOpts) {
          var startRangeOpts = this.metadata.discourseLocalDateStartRangeOpts;
          var endRangeOpts = buildOptionsFromMarkdownTag(this.element);

          var _markup = (0, _localDateMarkupGenerator.default)({
            date: startRangeOpts.date,
            time: startRangeOpts.time,
            format: startRangeOpts.format
          }, endRangeOpts, true, {
            date: endRangeOpts.date,
            time: endRangeOpts.time,
            format: endRangeOpts.format
          });

          this.prefix = _markup;
          this.metadata.discourseLocalDateStartRangeOpts = null;
          return "";
        }

        if (this.element.attributes["data-range"] === "true") {
          this.metadata.discourseLocalDateStartRangeOpts = buildOptionsFromMarkdownTag(this.element);
          return "";
        }

        var opts = buildOptionsFromMarkdownTag(this.element, siteSettings);
        var markup = (0, _localDateMarkupGenerator.default)({
          date: opts.date,
          time: opts.time,
          format: opts.format
        }, opts, false);
        this.prefix = markup;
        return "";
      }
    });
  }

  function buildHtmlPreview(element, siteSettings) {
    var opts = buildOptionsFromElement(element, siteSettings);
    var localDateBuilder = new _localDateBuilder.default(opts, moment.tz.guess()).build();
    var htmlPreviews = localDateBuilder.previews.map(function (preview) {
      var previewNode = document.createElement("div");
      previewNode.classList.add("preview");

      if (preview.current) {
        previewNode.classList.add("current");
      }

      var timezoneNode = document.createElement("span");
      timezoneNode.classList.add("timezone");
      timezoneNode.innerText = preview.timezone;
      previewNode.appendChild(timezoneNode);
      var dateTimeNode = document.createElement("span");
      dateTimeNode.classList.add("date-time");
      dateTimeNode.innerHTML = preview.formatted;
      previewNode.appendChild(dateTimeNode);
      return previewNode;
    });
    var previewsNode = document.createElement("div");
    previewsNode.classList.add("locale-dates-previews");
    htmlPreviews.forEach(function (htmlPreview) {
      return previewsNode.appendChild(htmlPreview);
    });

    var calendarNode = _downloadCalendarNode(element);

    if (calendarNode) {
      previewsNode.appendChild(calendarNode);
    }

    return previewsNode.outerHTML;
  }

  function calculateStartAndEndDate(startDataset, endDataset) {
    var startDate, endDate;
    startDate = moment.tz("".concat(startDataset.date, " ").concat(startDataset.time || "").trim(), startDataset.timezone);

    if (endDataset) {
      endDate = moment.tz("".concat(endDataset.date, " ").concat(endDataset.time || "").trim(), endDataset.timezone);
    }

    return [startDate, endDate];
  }

  function _downloadCalendarNode(element) {
    var _rangeElements$map = _rangeElements(element).map(function (dateElement) {
      return dateElement.dataset;
    }),
        _rangeElements$map2 = _slicedToArray(_rangeElements$map, 2),
        startDataset = _rangeElements$map2[0],
        endDataset = _rangeElements$map2[1];

    var _calculateStartAndEnd = calculateStartAndEndDate(startDataset, endDataset),
        _calculateStartAndEnd2 = _slicedToArray(_calculateStartAndEnd, 2),
        startDate = _calculateStartAndEnd2[0],
        endDate = _calculateStartAndEnd2[1];

    if (startDate < moment().tz(startDataset.timezone)) {
      return false;
    }

    var node = document.createElement("div");
    node.classList.add("download-calendar");
    node.innerHTML = "".concat((0, _iconLibrary.renderIcon)("string", "file"), " ").concat(_I18n.default.t("download_calendar.add_to_calendar"));
    node.setAttribute("data-starts-at", startDate.toISOString());

    if (endDataset) {
      node.setAttribute("data-ends-at", endDate.toISOString());
    }

    if (!startDataset.time && !endDataset) {
      node.setAttribute("data-ends-at", startDate.add(24, "hours").toISOString());
    }

    node.setAttribute("data-title", startDataset.title);
    return node;
  }

  function _calculateDuration(element) {
    var _rangeElements$map3 = _rangeElements(element).map(function (dateElement) {
      return dateElement.dataset;
    }),
        _rangeElements$map4 = _slicedToArray(_rangeElements$map3, 2),
        startDataset = _rangeElements$map4[0],
        endDataset = _rangeElements$map4[1];

    var startDateTime = moment("".concat(startDataset.date, " ").concat(startDataset.time || "").trim());
    var endDateTime = moment("".concat(endDataset.date, " ").concat(endDataset.time || "").trim());
    var duration = endDateTime.diff(startDateTime, "minutes"); // negative duration is used when we calculate difference for end date from range

    return element.dataset === startDataset ? duration : -duration;
  }

  var _default = {
    name: "discourse-local-dates",
    showDatePopover: function showDatePopover(event) {
      var _event$target, _event$target$classLi, _event$target2, _event$target2$classL;

      var owner = (0, _getOwner.getOwner)(this);

      if (owner.isDestroyed || owner.isDestroying) {
        return;
      }

      if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$classLi = _event$target.classList) !== null && _event$target$classLi !== void 0 && _event$target$classLi.contains("download-calendar")) {
        var dataset = event.target.dataset;
        (0, _downloadCalendar.downloadCalendar)(dataset.title, [{
          startsAt: dataset.startsAt,
          endsAt: dataset.endsAt
        }]); // TODO: remove this when rewriting preview as a component

        var parentPopover = event.target.closest("[data-tippy-root]");

        if (parentPopover !== null && parentPopover !== void 0 && parentPopover._tippy) {
          parentPopover._tippy.hide();
        }

        return;
      }

      if (!(event !== null && event !== void 0 && (_event$target2 = event.target) !== null && _event$target2 !== void 0 && (_event$target2$classL = _event$target2.classList) !== null && _event$target2$classL !== void 0 && _event$target2$classL.contains("discourse-local-date"))) {
        return;
      }

      var siteSettings = owner.lookup("service:site-settings");
      (0, _dPopover.showPopover)(event, {
        trigger: "click",
        content: buildHtmlPreview(event.target, siteSettings),
        allowHTML: true,
        interactive: true,
        appendTo: "parent",
        onHidden: function onHidden(instance) {
          instance.destroy();
        }
      });
    },
    hideDatePopover: function hideDatePopover(event) {
      (0, _dPopover.hidePopover)(event);
    },
    initialize: function initialize(container) {
      window.addEventListener("click", this.showDatePopover);
      var siteSettings = container.lookup("service:site-settings");

      if (siteSettings.discourse_local_dates_enabled) {
        $.fn.applyLocalDates = function () {
          (0, _deprecated.default)("`$.applyLocalDates()` is deprecated, import and use `applyLocalDates()` instead.");
          return applyLocalDates(this.toArray(), siteSettings);
        };

        (0, _pluginApi.withPluginApi)("0.8.8", initializeDiscourseLocalDates);
      }
    },
    teardown: function teardown() {
      window.removeEventListener("click", this.showDatePopover);
    }
  };
  _exports.default = _default;
});
function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

define("discourse/plugins/discourse-local-dates/lib/date-with-zone-helper", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  /*
    DateWithZoneHelper provides a limited list of helpers
    to manipulate a moment object with timezones
  
    - add(count unit) adds a COUNT of UNITS to a date
    - subtract(count unit) subtracts a COUNT of UNITS to a date
    - format(format) formats a date with zone in a consistent way, optional moment format
    - isDST() allows to know if a date in a specified timezone is currently under DST
    - datetimeWithZone(timezone) returns a new moment object with timezone applied
    - datetime returns the moment object
    - unitRepetitionsBetweenDates(duration, date) return the number of repetitions of
    duration between two dates, eg for duration: "1.weeks", "2.months"...
  */
  var DateWithZoneHelper = /*#__PURE__*/function () {
    function DateWithZoneHelper() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, DateWithZoneHelper);

      this.timezone = params.timezone || "UTC";
      this.localTimezone = params.localTimezone || moment.tz.guess();
      this.datetime = moment.tz((0, _object.getProperties)(params, ["year", "month", "day", "hour", "minute", "second"]), this.timezone);
    }

    _createClass(DateWithZoneHelper, [{
      key: "isDST",
      value: function isDST() {
        return this.datetime.tz(this.localTimezone).isDST();
      }
    }, {
      key: "unitRepetitionsBetweenDates",
      value: function unitRepetitionsBetweenDates(duration, date) {
        var _duration$split = duration.split("."),
            _duration$split2 = _slicedToArray(_duration$split, 2),
            count = _duration$split2[0],
            unit = _duration$split2[1]; // get the diff in the specified units with decimals


        var diff = Math.abs(this.datetime.diff(date, unit, true)); // get integer count of duration in diff, eg: 4 hours diff is 2 for 2.hours duration

        var integer = Math.trunc(diff / count); // get fractional to define if we have to add one "duration"

        var fractional = diff / count % 1;
        return integer * parseInt(count, 10) + (fractional > 0 ? parseInt(count, 10) : 0);
      }
    }, {
      key: "add",
      value: function add(count, unit) {
        return this._fromDatetime(this.datetime.clone().add(count, unit), this.timezone, this.localTimezone);
      }
    }, {
      key: "subtract",
      value: function subtract(count, unit) {
        return this._fromDatetime(this.datetime.clone().subtract(count, unit), this.timezone, this.localTimezone);
      }
    }, {
      key: "datetimeWithZone",
      value: function datetimeWithZone(timezone) {
        return this.datetime.clone().tz(timezone);
      }
    }, {
      key: "format",
      value: function format(_format) {
        if (_format) {
          return this.datetime.tz(this.localTimezone).format(_format);
        }

        return this.datetime.tz(this.localTimezone).toISOString(true);
      }
    }, {
      key: "_fromDatetime",
      value: function _fromDatetime(datetime, timezone, localTimezone) {
        return DateWithZoneHelper.fromDatetime(datetime, timezone, localTimezone);
      }
    }], [{
      key: "fromDatetime",
      value: function fromDatetime(datetime, timezone, localTimezone) {
        return new DateWithZoneHelper({
          year: datetime.year(),
          month: datetime.month(),
          day: datetime.date(),
          hour: datetime.hour(),
          minute: datetime.minute(),
          second: datetime.second(),
          timezone: timezone,
          localTimezone: localTimezone
        });
      }
    }]);

    return DateWithZoneHelper;
  }();

  _exports.default = DateWithZoneHelper;
});
define("discourse/plugins/discourse-local-dates/lib/discourse-markdown/discourse-local-dates", ["exports", "pretty-text/engines/discourse-markdown/bbcode-block"], function (_exports, _bbcodeBlock) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.setup = setup;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  var timezoneNames = moment.tz.names();

  function addSingleLocalDate(buffer, state, config) {
    var token = new state.Token("span_open", "span", 1);
    token.attrs = [["data-date", state.md.utils.escapeHtml(config.date)]];

    if (!config.date.match(/\d{4}-\d{2}-\d{2}/)) {
      closeBuffer(buffer, state, moment.invalid().format());
      return;
    }

    if (config.time && !config.time.match(/\d{2}:\d{2}(?::\d{2})?/)) {
      closeBuffer(buffer, state, moment.invalid().format());
      return;
    }

    var dateTime = config.date;

    if (config.time) {
      token.attrs.push(["data-time", state.md.utils.escapeHtml(config.time)]);
      dateTime = "".concat(dateTime, " ").concat(config.time);
    }

    if (!moment(dateTime).isValid()) {
      closeBuffer(buffer, state, moment.invalid().format());
      return;
    }

    token.attrs.push(["class", "discourse-local-date"]);

    if (config.format) {
      token.attrs.push(["data-format", state.md.utils.escapeHtml(config.format)]);
    }

    if (config.countdown) {
      token.attrs.push(["data-countdown", state.md.utils.escapeHtml(config.countdown)]);
    }

    if (config.calendar) {
      token.attrs.push(["data-calendar", state.md.utils.escapeHtml(config.calendar)]);
    }

    if (config.range) {
      token.attrs.push(["data-range", true]);
    }

    if (config.displayedTimezone && timezoneNames.includes(config.displayedTimezone)) {
      token.attrs.push(["data-displayed-timezone", state.md.utils.escapeHtml(config.displayedTimezone)]);
    }

    if (config.timezones) {
      var timezones = config.timezones.split("|").filter(function (timezone) {
        return timezoneNames.includes(timezone);
      });
      token.attrs.push(["data-timezones", state.md.utils.escapeHtml(timezones.join("|"))]);
    }

    if (config.timezone && timezoneNames.includes(config.timezone)) {
      token.attrs.push(["data-timezone", state.md.utils.escapeHtml(config.timezone)]);
      dateTime = moment.tz(dateTime, config.timezone);
    } else {
      dateTime = moment.utc(dateTime);
    }

    if (config.recurring) {
      token.attrs.push(["data-recurring", state.md.utils.escapeHtml(config.recurring)]);
    }

    buffer.push(token);
    var formattedDateTime = dateTime.tz("Etc/UTC").format(state.md.options.discourse.datesEmailFormat || moment.defaultFormat);
    token.attrs.push(["data-email-preview", "".concat(formattedDateTime, " UTC")]);
    closeBuffer(buffer, state, dateTime.utc().format(config.format));
  }

  function defaultDateConfig() {
    return {
      date: null,
      time: null,
      timezone: null,
      format: null,
      timezones: null,
      displayedTimezone: null,
      countdown: null,
      range: false
    };
  }

  function parseTagAttributes(tag) {
    var matchString = tag.replace(/‘|’|„|“|«|»|”/g, '"');
    return (0, _bbcodeBlock.parseBBCodeTag)("[date date" + matchString + "]", 0, matchString.length + 12);
  }

  function addLocalDate(buffer, matches, state) {
    var config = defaultDateConfig();
    var parsed = parseTagAttributes(matches[1]);
    config.date = parsed.attrs.date;
    config.format = parsed.attrs.format;
    config.calendar = parsed.attrs.calendar;
    config.time = parsed.attrs.time;
    config.timezone = (parsed.attrs.timezone || "").trim();
    config.recurring = parsed.attrs.recurring;
    config.timezones = parsed.attrs.timezones;
    config.displayedTimezone = parsed.attrs.displayedTimezone;
    config.countdown = parsed.attrs.countdown;
    addSingleLocalDate(buffer, state, config);
  }

  function addLocalRange(buffer, matches, state) {
    var config = defaultDateConfig();
    var date, time;
    var parsed = parseTagAttributes(matches[1]);
    config.format = parsed.attrs.format;
    config.calendar = parsed.attrs.calendar;
    config.timezone = (parsed.attrs.timezone || "").trim();
    config.recurring = parsed.attrs.recurring;
    config.timezones = parsed.attrs.timezones;
    config.displayedTimezone = parsed.attrs.displayedTimezone;
    config.countdown = parsed.attrs.countdown;
    config.range = parsed.attrs.from && parsed.attrs.to;

    if (parsed.attrs.from) {
      var _parsed$attrs$from$sp = parsed.attrs.from.split("T");

      var _parsed$attrs$from$sp2 = _slicedToArray(_parsed$attrs$from$sp, 2);

      date = _parsed$attrs$from$sp2[0];
      time = _parsed$attrs$from$sp2[1];
      config.date = date;
      config.time = time;
      addSingleLocalDate(buffer, state, config);
    }

    if (config.range) {
      closeBuffer(buffer, state, "→");
    }

    if (parsed.attrs.to) {
      var _parsed$attrs$to$spli = parsed.attrs.to.split("T");

      var _parsed$attrs$to$spli2 = _slicedToArray(_parsed$attrs$to$spli, 2);

      date = _parsed$attrs$to$spli2[0];
      time = _parsed$attrs$to$spli2[1];
      config.date = date;
      config.time = time;
      addSingleLocalDate(buffer, state, config);
    }
  }

  function closeBuffer(buffer, state, text) {
    var token;
    token = new state.Token("text", "", 0);
    token.content = text;
    buffer.push(token);
    token = new state.Token("span_close", "span", -1);
    buffer.push(token);
  }

  function setup(helper) {
    helper.allowList(["span.discourse-local-date", "span[aria-label]", "span[data-date]", "span[data-time]", "span[data-format]", "span[data-countdown]", "span[data-calendar]", "span[data-displayed-timezone]", "span[data-timezone]", "span[data-timezones]", "span[data-recurring]", "span[data-email-preview]"]);
    helper.registerOptions(function (opts, siteSettings) {
      opts.datesEmailFormat = siteSettings.discourse_local_dates_email_format;
      opts.features["discourse-local-dates"] = !!siteSettings.discourse_local_dates_enabled;
    });
    helper.registerPlugin(function (md) {
      var rule = {
        matcher: /\[date(=.+?)\]/,
        onMatch: addLocalDate
      };
      md.core.textPostProcess.ruler.push("discourse-local-dates", rule);
    });
    helper.registerPlugin(function (md) {
      var rule = {
        matcher: /\[date-range(.+?)\]/,
        onMatch: addLocalRange
      };
      md.core.textPostProcess.ruler.push("discourse-local-dates", rule);
    });
  }
});
function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

define("discourse/plugins/discourse-local-dates/lib/local-date-builder", ["exports", "./date-with-zone-helper", "I18n", "discourse-common/lib/icon-library"], function (_exports, _dateWithZoneHelper, _I18n, _iconLibrary) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  var DATETIME_FORMAT = "LLL";
  var DATE_FORMAT = "LL";
  var FULL_DATETIME_FORMAT = "LLLL";
  var TIME_FORMAT = "h:mm A";
  var DAY_OF_THE_WEEK_FORMAT = "dddd";
  var RANGE_SEPARATOR = "→";
  var TIME_ICON = "clock";
  var SHORT_FORMAT_DAYS_PERIOD = 1;

  var LocalDateBuilder = /*#__PURE__*/function () {
    function LocalDateBuilder() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var localTimezone = arguments.length > 1 ? arguments[1] : undefined;

      _classCallCheck(this, LocalDateBuilder);

      this.time = params.time;
      this.date = params.date;
      this.recurring = params.recurring;
      this.timezones = Array.from(new Set((params.timezones || []).filter(Boolean)));
      this.timezone = params.timezone || "UTC";
      this.calendar = typeof params.calendar === "undefined" ? true : params.calendar;
      this.displayedTimezone = params.displayedTimezone;
      this.format = params.format || (this.time ? DATETIME_FORMAT : DATE_FORMAT);
      this.countdown = params.countdown;
      this.duration = params.duration;
      this.localTimezone = localTimezone;
    }

    _createClass(LocalDateBuilder, [{
      key: "build",
      value: function build() {
        var _this$date$split$map = this.date.split("-").map(function (x) {
          return parseInt(x, 10);
        }),
            _this$date$split$map2 = _slicedToArray(_this$date$split$map, 3),
            year = _this$date$split$map2[0],
            month = _this$date$split$map2[1],
            day = _this$date$split$map2[2];

        var _split$map = (this.time || "").split(":").map(function (x) {
          return x ? parseInt(x, 10) : undefined;
        }),
            _split$map2 = _slicedToArray(_split$map, 3),
            hour = _split$map2[0],
            minute = _split$map2[1],
            second = _split$map2[2];

        var displayedTimezone;

        if (this.time) {
          displayedTimezone = this.displayedTimezone || this.localTimezone;
        } else {
          displayedTimezone = this.displayedTimezone || this.timezone || this.localTimezone;
        }

        var localDate = new _dateWithZoneHelper.default({
          year: year,
          month: month ? month - 1 : null,
          day: day,
          hour: hour,
          minute: minute,
          second: second,
          timezone: this.timezone,
          localTimezone: this.localTimezone
        });

        if (this.recurring && moment().isAfter(localDate.datetime)) {
          var type = this.recurring.split(".")[1];
          var repetitionsForType = localDate.unitRepetitionsBetweenDates(this.recurring, moment.tz(this.localTimezone));
          localDate = localDate.add(repetitionsForType, type);
        }

        var previews = this._generatePreviews(localDate, displayedTimezone);

        return {
          pastEvent: !this.recurring && moment.tz(this.localTimezone).isAfter(localDate.datetime),
          formatted: this._applyFormatting(localDate, displayedTimezone),
          previews: previews,
          textPreview: this._generateTextPreviews(previews)
        };
      }
    }, {
      key: "_generateTextPreviews",
      value: function _generateTextPreviews(previews) {
        var _this = this;

        return previews.map(function (preview) {
          var formattedZone = _this._zoneWithoutPrefix(preview.timezone);

          return "".concat(formattedZone, " ").concat(preview.formatted);
        }).join(", ");
      }
    }, {
      key: "_generatePreviews",
      value: function _generatePreviews(localDate, displayedTimezone) {
        var _this2 = this;

        var previewedTimezones = [];
        var timezones = this.timezones.filter(function (timezone) {
          return !_this2._isEqualZones(timezone, _this2.localTimezone);
        });
        previewedTimezones.push({
          timezone: this._zoneWithoutPrefix(this.localTimezone),
          current: true,
          formatted: this._createDateTimeRange(_dateWithZoneHelper.default.fromDatetime(localDate.datetime, localDate.timezone, this.localTimezone), this.time, this.duration)
        });

        if (this.timezone && displayedTimezone === this.localTimezone && this.timezone !== displayedTimezone && !this._isEqualZones(displayedTimezone, this.timezone) && !this.timezones.any(function (t) {
          return _this2._isEqualZones(t, _this2.timezone);
        })) {
          timezones.unshift(this.timezone);
        }

        timezones.forEach(function (timezone) {
          if (_this2._isEqualZones(timezone, displayedTimezone)) {
            return;
          }

          if (_this2._isEqualZones(timezone, _this2.localTimezone)) {
            timezone = _this2.localTimezone;
          }

          previewedTimezones.push({
            timezone: _this2._zoneWithoutPrefix(timezone),
            formatted: _this2._createDateTimeRange(_dateWithZoneHelper.default.fromDatetime(localDate.datetime, localDate.timezone, timezone), _this2.time, _this2.duration)
          });
        });
        return previewedTimezones.uniqBy("timezone");
      }
    }, {
      key: "_isEqualZones",
      value: function _isEqualZones(timezoneA, timezoneB) {
        if ((timezoneA || timezoneB) && (!timezoneA || !timezoneB)) {
          return false;
        }

        if (timezoneA.includes(timezoneB) || timezoneB.includes(timezoneA)) {
          return true;
        }

        return moment.tz(timezoneA).utcOffset() === moment.tz(timezoneB).utcOffset();
      }
    }, {
      key: "_createDateTimeRange",
      value: function _createDateTimeRange(startRange, time, duration) {
        var _this$_calculateDates = this._calculateDatesForRange(startRange, time, duration),
            _this$_calculateDates2 = _slicedToArray(_this$_calculateDates, 2),
            startDate = _this$_calculateDates2[0],
            endDate = _this$_calculateDates2[1];

        var formatElements = [startDate.format("".concat(DAY_OF_THE_WEEK_FORMAT, ", ").concat(DATE_FORMAT)), this._optionalTimeIcon(startDate, endDate), startDate.format(TIME_FORMAT)];

        if (endDate) {
          formatElements = formatElements.concat([RANGE_SEPARATOR, endDate.format(this._endDateFormat(startDate, endDate))]);
        }

        return formatElements.filter(Boolean).join(" ");
      }
    }, {
      key: "_shortFormat",
      value: function _shortFormat(startDate, endDate) {
        return endDate.datetime.diff(startDate.datetime, "days") < SHORT_FORMAT_DAYS_PERIOD;
      }
    }, {
      key: "_optionalTimeIcon",
      value: function _optionalTimeIcon(startDate, endDate) {
        if (!endDate || this._shortFormat(startDate, endDate)) {
          return "<br />".concat((0, _iconLibrary.renderIcon)("string", TIME_ICON));
        }
      }
    }, {
      key: "_endDateFormat",
      value: function _endDateFormat(startDate, endDate) {
        return this._shortFormat(startDate, endDate) ? TIME_FORMAT : FULL_DATETIME_FORMAT;
      }
    }, {
      key: "_calculateDatesForRange",
      value: function _calculateDatesForRange(date, time, duration) {
        // if a time has been given we do not attempt to automatically create a range
        // instead we show only one date with a format showing the time
        if (time && !duration) {
          return [date];
        }

        var dates = [date, duration ? date.add(duration, "minutes") : date.add(24, "hours")];
        return duration < 0 ? dates.reverse() : dates;
      }
    }, {
      key: "_applyFormatting",
      value: function _applyFormatting(localDate, displayedTimezone) {
        if (this.countdown) {
          var diffTime = moment.tz(this.localTimezone).diff(localDate.datetime);

          if (diffTime < 0) {
            return moment.duration(diffTime).humanize();
          } else {
            return _I18n.default.t("discourse_local_dates.relative_dates.countdown.passed");
          }
        }

        var sameTimezone = this._isEqualZones(displayedTimezone, this.localTimezone);

        if (this.calendar) {
          var inCalendarRange = moment.tz(this.localTimezone).isBetween(localDate.subtract(2, "day").datetime, localDate.add(1, "day").datetime.endOf("day"));

          if (inCalendarRange && sameTimezone) {
            var date = localDate.datetimeWithZone(this.localTimezone);

            if (date.hours() === 0 && date.minutes() === 0) {
              return date.format("dddd");
            }

            return date.calendar(moment.tz(localDate.timezone), this._calendarFormats(this.time ? this.time : null));
          }
        }

        if (!sameTimezone) {
          return this._formatWithZone(localDate, displayedTimezone, this.format);
        }

        return localDate.format(this.format);
      }
    }, {
      key: "_calendarFormats",
      value: function _calendarFormats(time) {
        return {
          sameDay: this._translateCalendarKey(time, "today"),
          nextDay: this._translateCalendarKey(time, "tomorrow"),
          lastDay: this._translateCalendarKey(time, "yesterday"),
          sameElse: "L"
        };
      }
    }, {
      key: "_translateCalendarKey",
      value: function _translateCalendarKey(time, key) {
        var translated = _I18n.default.t("discourse_local_dates.relative_dates.".concat(key), {
          time: "LT"
        });

        if (time) {
          return translated.split("LT").map(function (w) {
            return "[".concat(w, "]");
          }).join("LT");
        } else {
          return "[".concat(translated.replace(" LT", ""), "]");
        }
      }
    }, {
      key: "_formatTimezone",
      value: function _formatTimezone(timezone) {
        return timezone.replace("_", " ").replace("Etc/", "").split("/");
      }
    }, {
      key: "_zoneWithoutPrefix",
      value: function _zoneWithoutPrefix(timezone) {
        var _this$_formatTimezone = this._formatTimezone(timezone),
            _this$_formatTimezone2 = _slicedToArray(_this$_formatTimezone, 2),
            part1 = _this$_formatTimezone2[0],
            part2 = _this$_formatTimezone2[1];

        return part2 || part1;
      }
    }, {
      key: "_formatWithZone",
      value: function _formatWithZone(localDate, displayedTimezone, format) {
        var formatted = localDate.datetimeWithZone(displayedTimezone).format(format);
        return "".concat(formatted, " (").concat(this._zoneWithoutPrefix(displayedTimezone), ")");
      }
    }]);

    return LocalDateBuilder;
  }();

  _exports.default = LocalDateBuilder;
});
define("discourse/plugins/discourse-local-dates/lib/local-date-markup-generator", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = generateDateMarkup;

  function generateDateMarkup(fromDateTime, options, isRange, toDateTime) {
    var text = "";

    if (isRange) {
      var from = [fromDateTime.date, fromDateTime.time].filter(function (element) {
        return !(0, _utils.isEmpty)(element);
      }).join("T");
      var to = [toDateTime.date, toDateTime.time].filter(function (element) {
        return !(0, _utils.isEmpty)(element);
      }).join("T");
      text += "[date-range from=".concat(from, " to=").concat(to);
    } else {
      text += "[date=".concat(fromDateTime.date);
    }

    if (fromDateTime.time && !isRange) {
      text += " time=".concat(fromDateTime.time);
    }

    if (fromDateTime.format && fromDateTime.format.length) {
      text += " format=\"".concat(fromDateTime.format, "\"");
    }

    if (options.timezone) {
      text += " timezone=\"".concat(options.timezone, "\"");
    }

    if (options.countdown) {
      text += " countdown=\"".concat(options.countdown, "\"");
    }

    if (options.displayedTimezone) {
      text += " displayedTimezone=\"".concat(options.displayedTimezone, "\"");
    }

    if (options.timezones && options.timezones.length) {
      if (Array.isArray(options.timezones)) {
        text += " timezones=\"".concat(options.timezones.join("|"), "\"");
      } else {
        text += " timezones=\"".concat(options.timezones, "\"");
      }
    }

    if (options.recurring && !isRange) {
      text += " recurring=\"".concat(options.recurring, "\"");
    }

    text += "]";
    return text;
  }
});

